import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, TemplateRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeDocument } from '../../../shared/models/jobTypeDocument.model';

// import { CreateJobTypeComponent} from './create-job-type.component';

import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JobType } from '../../../shared/models/jobType.model';
import { SystemLogType } from 'src/app/shared/models/systemLogType.model';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { SystemLogTypeDataSectorCondition } from 'src/app/shared/models/systemLogTypeDataSectorCondition.model';
// import { SystemLogTypeDataSector } from 'src/app/shared/models/systemLogTypeDataSector.model';
import { SubjectServiceOutcomeTemplate } from 'src/app/shared/models/subjectServiceOutcomeTemplate.model';

@Component({
  selector: 'app-subject-service-outcome-template-create',
  templateUrl: './subject-service-outcome-template-create.component.html',
  styleUrls: ['./subject-service-outcome-template-create.component.scss']
})
export class SubjectServiceOutcomeTemplateCreateComponent implements OnInit {



  // model: SystemLogTypeDataSector;
  model: SubjectServiceOutcomeTemplate;
  job_types: Object;
  job_type_locations: Object;
  count2: any;
  get_latest_court_id: Object;
  job_type_courts: Object;
  sent_job_type_location_id: any;
  get_latest_document_id: Object;
  job_type_affidavit_types: Object;
  sent_job_type_document_type_id: any;
  get_latest_type_id: any;

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  get_latest_type_data_sector_id: Object;
  allResolutions: any[] = [];
  subject_service_resolution_outcomes: any;
  subject_service_resolution_outcomes_by_type: any[] = [];
  modalRef?: BsModalRef;

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef,
    public gfunc: GlobalFunctionsService
  ) { }

  ngOnInit() {
    this.model = new SubjectServiceOutcomeTemplate();
    this.model.subject_service_resolution_outcome_array = JSON.stringify([]);
    
  }



  createSystemLogType(model) {
    // console.log(model);
        this._demoService.createSystemLogType(model).subscribe(
             data => {  this.get_latest_type_id = data; // this is the retuned json upon creation.
             this.toastr.success('Log Type Created');
             this.closeParentModel.emit();
             this.gfunc.globalViewSystemLogTypesSkipRoute();
   // CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Job Type Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
             }
        );
        }
 

createSystemLogTypeDataSector(model) {
  // console.log(model);
      this._demoService.createSystemLogTypeDataSector(model).subscribe(
            data => {  this.get_latest_type_data_sector_id = data; // this is the retuned json upon creation.
            this.toastr.success('Log Type Data Sector Created');
            this.closeParentModel.emit();
            this.gfunc.globalViewSystemLogTypeDataSectorsSkipRoute();
  // CreateJobTypeComponent.returned.next(false);
              //  return true;
            },
            error => {
              this.toastr.error('Adding Log Type Data Sector Failed :: Please try again!');
              // console.log(Observable.throw(error));
              // return Observable.throw(error);
            }
      );
      }



  createSubjectSeviceOutcomeTemplate(model){
    model.subject_service_resolution_outcome_array = JSON.stringify(this.normaliseResolutionIds(this.allResolutions || []));
    this._demoService.createSubjectSeviceOutcomeTemplate(model).subscribe(
      data => {  this.get_latest_type_data_sector_id = data; // this is the retuned json upon creation.
      this.toastr.success('Subject Service Outcome Template Created');
      this.closeParentModel.emit();
      this.gfunc.globalViewSubjectServiceOutcomeTemplatesSkipRoute();
// CreateJobTypeComponent.returned.next(false);
        //  return true;
      },
      error => {
        this.toastr.error('Adding Subject Service Outcome Template Failed :: Please try again!');
        // console.log(Observable.throw(error));
        // return Observable.throw(error);
   
      }     
      );
    }

openModal(template: TemplateRef<any>) {
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

addResolutionFromModal(model, id) {
  const numericId = Number(id);
  if (!this.allResolutions) {
    this.allResolutions = [];
  }
  if (!this.allResolutions.some((resolutionId) => Number(resolutionId) === numericId)) {
    this.allResolutions.push(numericId);
  }
  this.allResolutions = this.normaliseResolutionIds(this.allResolutions);
  this.model.subject_service_resolution_outcome_array = JSON.stringify(this.allResolutions);
  this.getSystemResolutionsArray({ subject_service_resolution_outcome_array: this.allResolutions });
}

removeResolutionFromModal(model, id) {
  this.RemoveElementFromAllResolutions(Number(id));
}

RemoveElementFromAllResolutions(key: number) {
  this.allResolutions = this.normaliseResolutionIds(Object(this.allResolutions || []).filter((id: any) => Number(id) !== Number(key)));
  this.model.subject_service_resolution_outcome_array = JSON.stringify(this.allResolutions);
  this.getSystemResolutionsArray({ subject_service_resolution_outcome_array: this.allResolutions });
}

getSystemResolutionsArray(request_array) {
  this._demoService.getSystemResolutionsArray(request_array).subscribe(
     data => {
      this.subject_service_resolution_outcomes = data;
      this.subject_service_resolution_outcomes_by_type = this.groupResolutionOutcomesByType(data);
    },
     err => console.error(err),
   );
}

groupResolutionOutcomesByType(outcomes: any): any[] {
  const grouped = [];
  Object(outcomes || []).forEach((outcome) => {
    const typeId = Number(outcome.subject_service_resolution_outcome_type_id || 0);
    const typeName = outcome.subject_service_resolution_outcome_type_name || 'Unassigned';
    const typeActive = outcome.subject_service_resolution_outcome_type_is_active;
    if (typeActive != null && typeActive !== 1 && typeActive !== '1' && typeActive !== true && typeActive !== 'Y') {
      return;
    }
    let group = grouped.find(item => item.type_id === typeId);
    if (!group) {
      group = { type_id: typeId, type_name: typeName, outcomes: [] };
      grouped.push(group);
    }
    group.outcomes.push(outcome);
  });
  return grouped;
}

normaliseResolutionIds(value: any[]): any[] {
  const uniqueIds = [];
  Object(value || []).forEach((id: any) => {
    const numericId = Number(id);
    if (!isNaN(numericId) && !uniqueIds.some((selectedId) => Number(selectedId) === numericId)) {
      uniqueIds.push(numericId);
    }
  });
  return uniqueIds;
}

createSystemLogTypeDataSectorCondition(model) {
  // console.log(model);
      this._demoService.createSystemLogTypeDataSectorCondition(model).subscribe(
            data => {  this.get_latest_type_id = data; // this is the retuned json upon creation.
            this.toastr.success('Log Type Data Sector Condition Created');
            this.closeParentModel.emit();
            this.gfunc.globalViewSystemLogTypeDataSectorConditionsSkipRoute();
  // CreateJobTypeComponent.returned.next(false);
              //  return true;
            },
            error => {
              this.toastr.error('Adding Log Type Data Sector Condition Failed :: Please try again!');
              // console.log(Observable.throw(error));
              // return Observable.throw(error);
            }
      );
      }



  createJobType(model) {
    // console.log(model);
        this._demoService.createJobType(model).subscribe(
             data => {  this.get_latest_type_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */

             this.closeParentModel.emit();
   // CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Job Type Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
             }
        );
        }
 
 
        traceAddNotice () {
         this.toastr.info('Job Type Added');
       };
 



}
